import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Garantia() {
  return <section className="py-16 bg-court-gradient border-t border-white/5" data-id="element-104">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-105">
        <FadeIn data-id="element-106">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-neon/10 rounded-full mb-6" data-id="element-107">
            <ShieldCheck className="w-10 h-10 text-neon" data-id="element-108" />
          </div>
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-4 uppercase" data-id="element-109">
            Garantía de Satisfacción de 7 Días
          </h2>
          <p className="text-lg text-gray-300" data-id="element-110">
            Probá el contenido. Si sentís que no aporta valor a tu juego, te
            devolvemos tu dinero. Sin preguntas.
          </p>
        </FadeIn>
      </div>
    </section>;
}